<template>
  <div class="index-page" v-cloak>
    <div class="loading" v-show="loading">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="header">
      <div class="slogen">
        <img src="https://arbon2022-sh.oss-cn-shanghai.aliyuncs.com/cne/slogen.png">
      </div>
      <div class="invite-cont">
        <img class="box-bg" src="https://arbon2022-sh.oss-cn-shanghai.aliyuncs.com/cne/box-bg.png">
        <div class="invite-info">
          <img v-show="logoUrl" class="logo" :src="logoUrl">
          <h2 v-show="customBrandName">{{ customBrandName||'' }}</h2>
<!--          <span>诚邀您参观“上海国际碳中和博览会”<br>-->
<!--          聚焦绿色低碳，携手走向碳中和之路</span>-->
          <div class="booth-info" v-if="exhibitorInfo.stadiumsIdName || exhibitorInfo.positionNumber"  >
            <div class="text" v-if="exhibitorInfo.stadiumsIdName" >{{ exhibitorInfo.stadiumsIdName }}</div>
            <span class="dian" v-if="exhibitorInfo.stadiumsIdName"></span>
            <div class="text" v-if="exhibitorInfo.positionNumber">{{ exhibitorInfo.positionNumber }}</div>
          </div>
        </div>
      </div>
    </div>
    <!--轮播-->
    <div class="title"  v-if="productList.length>0">
      <img src="https://arbon2022-sh.oss-cn-shanghai.aliyuncs.com/cne/ldjhd.png">
    </div>
    <section class="pc-banner" v-if="productList.length>0">
      <div class="swiper-slide" v-for="item in productList" :key="item.index">
        <div class="img-cont">
          <img :src="item.fileUrl"/>
        </div>
        <div class="desc">
          <h5>{{ item.name }}</h5>
          <div class="detail " :class="item.moreShow?'':'detail-view'">
            {{ item.introduction }}
            <div class="readMore" v-if="!item.moreShow && item.introduction.length > 65" @click="toggleShow(item)">展开</div>
            <div class="readMore" v-if="item.moreShow" @click="toggleShow(item)">收起</div>
          </div>
        </div>
      </div>
    </section>
    <div class="title" v-if="activityList.length>0">
      <img src="https://arbon2022-sh.oss-cn-shanghai.aliyuncs.com/cne/wdld.png">
    </div>
    <ul class="ld-list" v-if="activityList.length>0">
      <li v-for="item in activityList">
        <img :src="item.fileUrl">
        <div class="title-ld">
          <h5>{{item.name}}</h5>
          <div class="detail" :class="item.moreShow?'':'detail-view'">{{ item.introduction }}
            <div class="readMore" v-if="!item.moreShow && item.introduction.length > 65" @click="toggleShow(item)">展开</div>
            <div class="readMore" v-if="item.moreShow" @click="toggleShow(item)">收起</div>
          </div>
        </div>
      </li>
    </ul>
    <img src="https://arbon2022-sh.oss-cn-shanghai.aliyuncs.com/cne/block1.png">
    <img src="https://arbon2022-sh.oss-cn-shanghai.aliyuncs.com/cne/block2.png">
    <div class="fixed-bottom" @click="openWeapp()">
      <button>
        <p>立即预登记</p>
        <span>REGISTER NOW</span>
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import data from "../util/data"

export default {
  data() {
    return {
      loading:false,
      isShow: false,
      someList: [],
      exhibitorInfo: {},
      //活动列表
      activityList: [],
      //产品列表
      productList: [],
      imgBaseUrl:data.getImgs,
      productSlide:[

      ],
      exhibitId:"",
      exhibitorId:"",
      tenantId:"",
      openlink:"",
      logoUrl:"",
      customBrandName:''
    }
  },
  created() {
    this.exhibitId = this.getUrlKey("exhibitId");
    this.exhibitorId = this.getUrlKey("exhibitorId");
    this.tenantId = this.getUrlKey("tenantId");
    if (this.exhibitId && this.exhibitorId && this.tenantId){
      this.loading = true;
      this.loadExhibitor();
      this.loadExhibitorProduct();
      this.loadLogoForm();

    }
  },
  methods: {
    toggleShow(item) {
      item.moreShow = !item.moreShow;
    },
    async openWeapp() {
      if (this.openlink != null) {
        location.href = this.openlink
      }
    },

    /**
     * 加载展商信息
     */
    loadExhibitor() {
      let that = this;
      axios.get( data.exhibitorInvitationInfo + "?exhibitId="
        + this.exhibitId + "&exhibitorId=" + this.exhibitorId)
        .then(function (res) {
          if (res.data.code == 200) {
            that.exhibitorInfo = res.data.data
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },


    async getFile(fileUrl) {
      let resFile = "";
      if (!fileUrl) {
        return;
      }

      var fileRes = await axios.get( data.getImg + "?tenantId=" + this.tenantId + "&id=" + fileUrl)

      if (fileRes.data.code == 200 && fileRes.data.data) {
        resFile = fileRes.data.data.fileBase64 ? fileRes.data.data.fileBase64 : ""
      }
      return resFile;
    },


    /**
     * 加载展品信息
     */
    async loadExhibitorProduct() {
      let that = this;
      let res = await axios.get( data.getFormDetail + "?formId=" + data.productFormId + "&exhibitId=" + this.exhibitId + "&exhibitorId=" + this.exhibitorId)


      if (res.data.code == 200) {
        if (res.data.data && res.data.data[0].formItems) {

          let nameList = []
          let introductionList = []
          let fileList = []
          //活动数据
          let activityNameList = []
          let activityIntroductionList = []
          let activityFileList = []

          for (const item of res.data.data[0].formItems) {
            if(item.formItemProp.indexOf('custom_brand_name')>-1){
              this.customBrandName = item.fillContent;
            }
            if (item.formItemProp.indexOf("product_name") > -1) {
              nameList.push(item.fillContent)
            }
            if (item.formItemProp.indexOf("product_introduction") > -1) {
              introductionList.push(item.fillContent)
            }
            if (item.formItemProp.indexOf("product_fileUrl") > -1) {
              let base64 = await that.getFile(item.fillContent)
              fileList.push(base64)
            }

            //活动数据赋值
            if (item.formItemProp.indexOf("activity_name") > -1) {
              activityNameList.push(item.fillContent)
            }
            if (item.formItemProp.indexOf("activity_introduction") > -1) {
              activityIntroductionList.push(item.fillContent)
            }
            if (item.formItemProp.indexOf("activity_fileUrl") > -1) {
              let base64 = await that.getFile(item.fillContent)
              activityFileList.push(base64)
            }
          }
          that.productList = [];
          for (let i = 0; i < nameList.length; i++) {
            if(fileList[i]){
              that.productList.push({
                moreShow:false,
                name: nameList[i],
                introduction: introductionList[i],
                fileUrl: fileList[i]
              })
            }
          }

          //赋值活动
          that.activityList=[]
          for (let i = 0; i < activityFileList.length; i++) {
            if(activityFileList[i]){
              that.activityList.push({
                moreShow:false,
                name: activityNameList[i],
                introduction: activityIntroductionList[i],
                fileUrl: activityFileList[i]
              })
            }
          }
        }

        this.getWechatConfig();
        this.generatescheme();
        this.loading = false;
      }



    },

    /**
     * 加载展品信息
     */
    async loadLogoForm() {
      let that = this;
      let res = await axios.get( data.getFormDetail + "?formId=" + data.logoFormId + "&exhibitId=" + this.exhibitId + "&exhibitorId=" + this.exhibitorId)


      if (res.data.code == 200) {
        if (res.data.data && res.data.data[0].formItems) {
          for (const item of res.data.data[0].formItems) {
            if (item.formItemProp.indexOf("image_publication") > -1) {
              let fillContent = item.fillContent? item.fillContent.split(",")[0]:""
              that.logoUrl = await that.getFile(fillContent)
            }
          }
        }
      }

    },

    getWechatConfig() {
      let that = this;
      axios.post( data.getWechatConfig, {
        url: window.location.href.split('#')[0],
        exhibitId: this.exhibitId
      },{
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      }).then(res => {
        if (res.data.code == 200) {

          that.onLoaded(res.data.data);
        }
      })
    },


    generatescheme() {
      axios.post( data.generatescheme, {
        exhibitId: this.exhibitId,
        exhibitorId: this.exhibitorId,
        domainType: 2
      }).then(res => {
        if(res.data.code==200){
          this.openlink=res.data.data.openlink
        }
      })
    },

    onLoaded(v) {
      this.username = v.jwId;
      wx.config({
        //debug: true, // 调试时可开启
        appId: v.appid, // 必填，公众号的唯一标识
        timestamp: v.timestamp, // 必填，生成签名的时间戳
        nonceStr: v.nonceStr, // 必填，生成签名的随机串
        signature: v.signature,// 必填，签名，见附录1
        jsApiList: ["updateAppMessageShareData", "updateTimelineShareData","onMenuShareTimeline","onMenuShareAppMessage"],
        openTagList: ['wx-open-launch-weapp'], // 填入打开小程序的开放标签名
      })
      let _self = this;
      wx.ready(function () {

        let desc = "2023.6.11-14 \r\n国家会展中心（上海）\r\n"+_self.exhibitorInfo.stadiumsIdName+" "+ _self.exhibitorInfo.positionNumber;

        if(!_self.exhibitorInfo.stadiumsIdName && !_self.exhibitorInfo.positionNumber ){
          desc = "2023.6.11-14 \r\n国家会展中心（上海）\r\n";
        }


        let shareContent = {
          title: (_self.customBrandName||'')+' 诚邀参观  \r\n上海国际碳中和博览会', // 分享标题
          link: window.location.href.split('#')[0],
          desc: desc,
          imgUrl: "https://arbon2022-sh.oss-cn-shanghai.aliyuncs.com/cne/cne-logo3.jpg"
        }
        wx.updateTimelineShareData(shareContent);

        wx.updateAppMessageShareData(shareContent)

      });
      wx.error(function (res) {
        console.log('res', res);
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      });
    },

    /***
     * 获取url中的参数
     * @param name
     * @returns {string | null}
     */
    getUrlKey(name) {
      let r = new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""];
      return decodeURIComponent(r[1].replace(/\+/g, '%20')) || null;
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
[v-cloak] {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/page/index.vue